import { Injectable, ViewContainerRef } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class ErrorContainerService {
	public viewContainerRef: ViewContainerRef | null = null;
	constructor() {}
}
